export default "__VITE_ASSET__be126c19__"